import { Injectable } from '@angular/core';
import { NgxCaptureService } from 'ngx-capture';

@Injectable({
	providedIn: 'root'
})
export class ScreenCaptureService extends NgxCaptureService {

	constructor() {
		super();
	}

	base64ToImageBlob(dataURI: string) {
		const splitDataURI = dataURI.split(',');
		const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
		const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

		const ia = new Uint8Array(byteString.length);
		for (let i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}
		return new Blob([ia], { type: mimeString });
	}

	dataURLtoFile(dataUrl, filename) {
		const arr = dataUrl.split(',');
		const mime = arr[0]?.match(/:(.*?);/)[1];
		const bstr = atob(arr[1]);
		let n = bstr?.length;
		const u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr?.charCodeAt(n);
		}
		return new File([u8arr], filename, { type: mime });
	}

	getFileFromBlob(blob, fileName) {
		const file = new File([blob], fileName, { type: blob.type });
		return file;
	}

	base64ToFile(base64, fileName) {
		const blob = this.base64ToImageBlob(base64);
		const file = this.getFileFromBlob(blob, fileName);
		return file;
	}

}
